import * as React from 'react';
import { formatCondensedHumanDate, formatShortHumanMonth } from '~/DateTime';
import { calculateYearPeriod } from '~/ExchangeRate/calculateYearPeriod';
import { calculateYearQuarter } from '~/ExchangeRate/calculateYearQuarter';

export enum TimePeriod {
	daily = 'daily',
	fixed = 'fixed',
	previous12MonthsAvg = 'previous-12-months-avg',
	previousQuarterAvg = 'previous-quarter-avg',
}

export const RateTimePeriod: React.FunctionComponent<
	React.PropsWithChildren<{
		averageLabel?: string;
		date: Date;
		fromLabel?: string;
		timePeriod: TimePeriod;
	}>
> = ({ averageLabel = 'Average', date, fromLabel = 'From', timePeriod }) => {
	switch (timePeriod) {
		case TimePeriod.daily:
		case TimePeriod.fixed:
			return (
				<>
					{fromLabel} {formatCondensedHumanDate(date)}
				</>
			);

		case TimePeriod.previous12MonthsAvg: {
			const [fromDate, toDate] = calculateYearPeriod(date);
			return (
				<>
					{averageLabel} of {formatShortHumanMonth(fromDate)}-{formatShortHumanMonth(toDate)}
				</>
			);
		}

		case TimePeriod.previousQuarterAvg: {
			const [year, quarter] = calculateYearQuarter(date);
			return (
				<>
					{averageLabel} of {year}Q{quarter}
				</>
			);
		}

		default:
			return <></>;
	}
};
